import React, { useState } from "react";
import {
  message,
  Modal,
  Form,
  Input,
} from "antd";
import { campainAPIWithErrorHandling, campainHelpers } from "../../../api/collection/campain";

// Duplicate Modal Component
const DuplicateCampaignModal = ({ visible, onCancel, onSuccess, collection }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const options = {
        name: values.name,
      };

      // Validate options
      const validation = campainHelpers.validateDuplicateOptions(options);
      if (!validation.isValid) {
        Object.values(validation.errors).forEach(error => {
          message.error(error);
        });
        return;
      }

      const response = await campainAPIWithErrorHandling.duplicateCampain(
        collection.id,
        options
      );

      message.success('Sao chép đợt thu thành công!');
      form.resetFields();
      onSuccess(response);
    } catch (error) {
      message.error(error.message || 'Không thể sao chép đợt thu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Sao chép đợt thu: ${collection?.name}`}
      open={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={600}
      okText="Sao chép"
      cancelText="Hủy"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          name: campainHelpers.generateDuplicateName(collection?.name || ''),
        }}
      >
        <Form.Item
          label="Tên đợt thu mới"
          name="name"
          rules={[
            { required: true, message: 'Vui lòng nhập tên đợt thu' },
            { max: 255, message: 'Tên không được vượt quá 255 ký tự' },
          ]}
        >
          <Input placeholder="Nhập tên đợt thu mới" />
        </Form.Item>
      </Form>
    </Modal>
  );
};


export default DuplicateCampaignModal;